// функция, которая находит в ответе ллм ссылки (включая имейлы и номера телефонов) и форматирует их как маркдаун-ссылки.
// здесь учтено, что ссылка может прийти уже отформатированной.

// export const URL_REGEX = new RegExp(`((https?:\\/\\/|www\\.)[^\\s]{2,})`, 'gi');
export const URL_REGEX = new RegExp(
  `((https?:\\/\\/|www\\.)[^\\s]{2,})(?<![.,;:!?()\\[\\]])`,
  'gi',
);

const EMAIL_REGEX = new RegExp(`[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}`, 'g');
// для русских номеров
const PHONE_REGEX =
  /(\+7|7|8)[\s\-]?(?:\([0-9]{3}\)|[0-9]{3})[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}(?!\d)/g;

export const formatTextLinksForMarkdown = (text: string): string => {
  if (!text) return text;

  console.log('>>> not formatted', `"${text}"`);

  let processedText = text;

  // -----------------------------
  // Экранируем содержимое тегов <img>...</img> (гуиды для стораджа)
  // -----------------------------
  const imgPlaceholders: string[] = [];

  processedText = processedText.replace(/<img>[^<]*<\/img>/g, (match) => {
    const placeholder = `__IMG_PLACEHOLDER_${imgPlaceholders.length}__`;
    imgPlaceholders.push(match);
    return placeholder;
  });

  // -----------------------------
  // Экранируем inline code (`...`)
  // -----------------------------
  const codePlaceholders: string[] = [];

  processedText = processedText.replace(/`[^`]*`/g, (match) => {
    const placeholder = `__CODE_PLACEHOLDER_${codePlaceholders.length}__`;
    codePlaceholders.push(match);
    return placeholder;
  });

  // -----------------------------
  // Экранируем уже отформатированные markdown-ссылки
  // -----------------------------
  const linkPlaceholders: string[] = [];

  processedText = processedText.replace(/\[[^\]]+\]\([^)]+\)/g, (match) => {
    const placeholder = `__LINK_PLACEHOLDER_${linkPlaceholders.length}__`;
    linkPlaceholders.push(match);
    return placeholder;
  });

  // -----------------------------
  // Форматируем оставшиеся ссылки
  // -----------------------------
  processedText = processedText.replace(
    new RegExp([URL_REGEX.source, EMAIL_REGEX.source, PHONE_REGEX.source].join('|'), 'gi'),
    (match) => {
      if (match.match(URL_REGEX)) {
        let url = match;
        if (!url.startsWith('http')) {
          url = 'http://' + url;
        }
        return `[${match}](${url})`;
      }

      if (match.match(EMAIL_REGEX)) {
        return `[${match}](mailto:${match})`;
      }

      if (match.match(PHONE_REGEX)) {
        const cleanPhone = match.replace(/[-.\s()]/g, '');
        return `[${match}](tel:${cleanPhone})`;
      }

      return match;
    },
  );

  // -----------------------------
  // Восстанавливаем markdown-ссылки
  // -----------------------------
  linkPlaceholders.forEach((original, index) => {
    processedText = processedText.replace(`__LINK_PLACEHOLDER_${index}__`, original);
  });

  // -----------------------------
  // Восстанавливаем inline code
  // -----------------------------
  codePlaceholders.forEach((original, index) => {
    processedText = processedText.replace(`__CODE_PLACEHOLDER_${index}__`, original);
  });

  // -----------------------------
  // Восстанавливаем теги <img>...</img>
  // -----------------------------
  imgPlaceholders.forEach((original, index) => {
    processedText = processedText.replace(`__IMG_PLACEHOLDER_${index}__`, original);
  });

  console.log('>>> formatted', `"${processedText}"`);

  return processedText;
};
